import { doodModalConfig } from './dood-modal-config';
import { propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const UNVERIFIEDUSEREMAILALERTMODAL_LEGACY_FIELD_ORDER = [
  "heading_color",
  "close_icon_color",
  "close_icon_background_color",
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  unverifiedUserEmailAlertModalDescriptor: _generatedUnverifiedUserEmailAlertModalDescriptor,
  unverifiedUserEmailAlertModalModalDefinition,
  unverifiedUserEmailAlertModalDashboardLayout,
  unverifiedUserEmailAlertModalConfig,
  unverifiedUserEmailAlertModalResolveConfig,
  unverifiedUserEmailAlertModalProperties,
} = doodModalConfig(
  {
    name: "UnverifiedUserEmailAlertModal",
    handle: "unverified-user-email-alert-modal",
    internal_name: "UnverifiedUserEmailAlertModal",
    componentType: 'UnverifiedUserEmailAlertModalComponent',
    category: 'modal',
    description: "UnverifiedUserEmailAlertModal.",
    keywords: [],
    isContentModal: true,
    defaultHandle: "unverified-user-email-alert-modal",
    sharedFields: {}
  },

  () => ({
    heading_color: propertyValue({
      type: 'color',
      value: {"type":"default","value":"#000"},
      options: {
        "label": "UnverifiedUserEmailAlertModal.heading_color"
      }
    }),
    close_icon_color: propertyValue({
      type: 'color',
      value: { type: 'palette', value: 'primary-900' },
      options: {
        label: 'Color of the close icon',
      },
    }),
    close_icon_background_color: propertyValue({
      type: 'color',
      value: { type: 'palette', value: 'primary-200' },
      options: {
        label: 'Background color of the close icon',
      },
    }),
  }),

  () => ({
    tabs: [
      {
        label: 'Design',
        fieldsets: [
          {
            legend: 'Properties',
            fields: ["heading_color", "close_icon_color", "close_icon_background_color"],
          },
        ],
      },
    ],
  })
);

export function unverifiedUserEmailAlertModalDescriptor(): IBlockDescriptor;
export function unverifiedUserEmailAlertModalDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function unverifiedUserEmailAlertModalDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedUnverifiedUserEmailAlertModalDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedUnverifiedUserEmailAlertModalDescriptor, unverifiedUserEmailAlertModalProperties, fieldOrder);
}

export {
  unverifiedUserEmailAlertModalModalDefinition,
  unverifiedUserEmailAlertModalDashboardLayout,
  unverifiedUserEmailAlertModalProperties,
  unverifiedUserEmailAlertModalConfig,
  unverifiedUserEmailAlertModalResolveConfig,
};

export type UnverifiedUserEmailAlertModalConfig = typeof unverifiedUserEmailAlertModalConfig;
